<template>
	<side-window :tabs="tabs" :active="active" class="contact" title="Timer" @pop="$emit('pop')" @close="$emit('close')" @tabSelect="tabSelect">
		<div v-if="!id || (form && id)">
			<form-grid-layout>
				<div v-show="active == 'details'">
					<info-view v-for="(word, i) in this.ent.search" :key="i">En kommentar indeholder ordet '{{ word }}'</info-view>
					<form-line-layout>
						<clock-select-view label="Timer" v-model="ent.hours" :controller="$store.state.popupController" />
					</form-line-layout>
					<form-line-layout>
						<number-view label="Tillæg" v-model="ent.extra" />
					</form-line-layout>
					<form-line-layout>
						<text-view label="Bemærkning" v-model="ent.remarks" :height="300" />
					</form-line-layout>
				</div>
			</form-grid-layout>
		</div>
		<div slot="footer">
			<button-view label="Nulstil" @click="onResetButtonClick" />
			<button-view label="Godkend" @click="onAddButtonClick" />
		</div>
	</side-window>
</template>

<script>
	import MoveTaskModel from '../model/MoveTask'

	import TextView from '../views/TextView';
	import StringView from '../views/StringView';
	import FileListView from '../views/FileListView';
	import RouteView from '../views/RouteView';
	import RequirementsView from '../views/RequirementsView';
	import PhotosView from '../views/PhotosView';
	import InstructionsView from '../views/InstructionsView';
	import PackagingView from '../views/PackagingView';
	import OrderView from '../views/OrderView';
	import EmployeeSelectView from '../views/EmployeeSelectView';
	import AddressView from '../views/AddressView';

	import merge from '../functions/merge'
 
	import { bus } from '../../bus';

	const stop = {

	};

	export default {
		data: function () {
			return {
				packaging: [],
				ORDER: [],
				active: 'details',
				instructions: [],
				departments: [],
				types: [],
				status: [],
				employees: [],
				vehicles: [],



				ent: {
					hours: 0,
					extra: '',
					remarks: '',
					name: 'Nicolaj Andersen',
					search: ['byrde']
				}
			};
		},
		watch: {
			'ent.extra': {
				handler(n) {
					
				}
			}
		},
		components: {
			'TextView': TextView,
			'StringView': StringView,
			'FileListView': FileListView,
			'RouteView': RouteView,
			'RequirementsView': RequirementsView,
			'PhotosView': PhotosView,
			'InstructionsView': InstructionsView,
			'PackagingView': PackagingView,
			'OrderView': OrderView,
			'EmployeeSelectView': EmployeeSelectView,
			'AddressView': AddressView
		},
		computed: {
			tabs: function () {
				return [
					{
						name: 'details',
						label: this.ent.name
					}
				];
			},
			_employees() {
				return this.employees.map(function (ent) {
					return {
						label: ent.name,
						value: ent.id
					};
				});
			},
			_vehicles() {
				return this.vehicles.map(function (ent) {
					return {
						label: ent.name,
						value: ent.id
					};
				});
			}
		},
		props: {
			id: Number,
			form: Boolean,
			from_date: String,
			from_time: String,
			to_date: String,
			to_time: String,
			submit: {
				type: Function,
				default: function () {}
			},
			reset: {
				type: Function,
				default: function () {}
			},
			entity: {
				type: Object,
				default() {
					return {};
				}
			}
		},
		methods: {
			tabSelect(name, tabName) {
				
				this.active = tabName;
			},
			onAddButtonClick() {
				
				this.submit(this.ent);
			},
			async onResetButtonClick() {
				//
				//this.submit(this.ent);

				
				this.reset(this.ent);
			}
		},
		mounted: function() {
			
			

			var self = this;

			this.ent = Object.assign(this.ent, this.entity);

			// Correnct hours
			this.ent.hours = Math.round(this.$options.filters.roundHours(this.ent.hours) * 60);

			/*this.axios
				.get('/us/departments/')
				.then(function (r) {
					self.departments = r.data._items;
					//self.entity.roles = {...self._roles, ...self.entity.roles};
				});*/

		}
	}
</script>

<style lang="scss">
	
</style>
